import { INVENTORY_BINS } from "../../constants/routes";

export function binInventoryLink(binBarcode: string) {
  return `${INVENTORY_BINS}/${binBarcode}`;
}

export function containerInventoryLink(containerBarcode: string) {
  return `/internal/parts/containers/${containerBarcode}`;
}
